export default "__VITE_ASSET__OSI2KqDd__"